<template>
	<sf-data-table rowSize="lg" :columns="parameterColumns" :rows="rows" height="100%" @changedRow="changedRow"> </sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
export default {
	props: {
		parameterRows: { type: Array, default: () => [] }
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changedRow({ rows, changedRow }) {
			//console.log('@@[changedRow] rows: ', rows);
			//console.log('@@[changedRow] changedRow: ', changedRow);
			this.$emit('changedRow', rows);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		rows() {
			return this.parameterRows;
		},
		parameterColumns() {
			return [
				{
					label: this.getMessage_('SWCC000863'),
					prop: 'parameterName'
				},
				{
					label: this.getMessage_('SWCC000864'),
					prop: 'parameterValue',
					form: {
						type: 'input',
						maxLength: 100
					}
				}
			];
		}
	}
};
</script>

<style langType="scss"></style>
